/**
 * Native-backed themed select skins.
 *
 * The real <select> remains the interactive, labelled, keyboard-accessible
 * control. The generated trigger is visual only, so we avoid fragile custom
 * combobox semantics while keeping the themed closed-state appearance.
 */
export function initCustomSelects() {
  const selects = document.querySelectorAll('select');

  selects.forEach((select) => {
    if (select.dataset.customInitialized) return;
    select.dataset.customInitialized = 'true';

    let wrapper = select.parentElement;
    if (!wrapper.classList.contains('select-wrapper')) {
      const nextWrapper = document.createElement('div');
      nextWrapper.className = 'select-wrapper';
      select.parentNode.insertBefore(nextWrapper, select);
      nextWrapper.appendChild(select);
      wrapper = nextWrapper;
    }

    const trigger = document.createElement('div');
    trigger.className = 'custom-select-trigger';
    trigger.setAttribute('aria-hidden', 'true');

    const textSpan = document.createElement('span');
    textSpan.className = 'custom-select-text';

    const arrowSpan = document.createElement('span');
    arrowSpan.className = 'custom-select-arrow';
    arrowSpan.textContent = '▼';

    trigger.appendChild(textSpan);
    trigger.appendChild(arrowSpan);
    wrapper.appendChild(trigger);

    function syncTriggerText() {
      const activeOption = select.options[select.selectedIndex];
      textSpan.textContent = activeOption ? activeOption.textContent : '';
    }

    select.__frontMyEndSyncCustomSelect = syncTriggerText;
    select.addEventListener('change', syncTriggerText);
    new MutationObserver(syncTriggerText).observe(select, {
      childList: true,
      subtree: true
    });
    syncTriggerText();
  });
}

export function syncCustomSelect(select) {
  if (!select || typeof select.__frontMyEndSyncCustomSelect !== 'function') return;
  select.__frontMyEndSyncCustomSelect();
}
